module.exports = __webpack_public_path__ + "img/automasi_indikasi_dex_palsu.0648b27e.svg";